/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPREMIUMFREQUENCY } from './IAPPREMIUMFREQUENCY';
import {
    IAPPREMIUMFREQUENCYFromJSON,
    IAPPREMIUMFREQUENCYFromJSONTyped,
    IAPPREMIUMFREQUENCYToJSON,
} from './IAPPREMIUMFREQUENCY';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface InvestmentDetailsRecurringContributionViewModel
 */
export interface InvestmentDetailsRecurringContributionViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    grossAmount?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    firstDebitOrderDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    annualGrowthRatePercentage?: number;
    /**
     * 
     * @type {IAPPREMIUMFREQUENCY}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    contributionFrequency?: IAPPREMIUMFREQUENCY;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    hasRecurringContribution: IAPYESORNO;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    isRecurringContributionValid?: boolean;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    hasGrowthRate?: IAPYESORNO;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    growthRatePercentage?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsRecurringContributionViewModel
     */
    growthDate?: Date;
}

/**
 * Check if a given object implements the InvestmentDetailsRecurringContributionViewModel interface.
 */
export function instanceOfInvestmentDetailsRecurringContributionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasRecurringContribution" in value;

    return isInstance;
}

export function InvestmentDetailsRecurringContributionViewModelFromJSON(json: any): InvestmentDetailsRecurringContributionViewModel {
    return InvestmentDetailsRecurringContributionViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsRecurringContributionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsRecurringContributionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'grossAmount': !exists(json, 'GrossAmount') ? undefined : json['GrossAmount'],
        'firstDebitOrderDate': !exists(json, 'FirstDebitOrderDate') ? undefined : (new Date(json['FirstDebitOrderDate'])),
        'annualGrowthRatePercentage': !exists(json, 'AnnualGrowthRatePercentage') ? undefined : json['AnnualGrowthRatePercentage'],
        'contributionFrequency': !exists(json, 'ContributionFrequency') ? undefined : IAPPREMIUMFREQUENCYFromJSON(json['ContributionFrequency']),
        'hasRecurringContribution': IAPYESORNOFromJSON(json['HasRecurringContribution']),
        'isRecurringContributionValid': !exists(json, 'IsRecurringContributionValid') ? undefined : json['IsRecurringContributionValid'],
        'hasGrowthRate': !exists(json, 'HasGrowthRate') ? undefined : IAPYESORNOFromJSON(json['HasGrowthRate']),
        'growthRatePercentage': !exists(json, 'GrowthRatePercentage') ? undefined : json['GrowthRatePercentage'],
        'growthDate': !exists(json, 'GrowthDate') ? undefined : (new Date(json['GrowthDate'])),
    };
}

export function InvestmentDetailsRecurringContributionViewModelToJSON(value?: InvestmentDetailsRecurringContributionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'GrossAmount': value.grossAmount,
        'FirstDebitOrderDate': value.firstDebitOrderDate === undefined ? undefined : (value.firstDebitOrderDate.toISOString()),
        'AnnualGrowthRatePercentage': value.annualGrowthRatePercentage,
        'ContributionFrequency': IAPPREMIUMFREQUENCYToJSON(value.contributionFrequency),
        'HasRecurringContribution': IAPYESORNOToJSON(value.hasRecurringContribution),
        'IsRecurringContributionValid': value.isRecurringContributionValid,
        'HasGrowthRate': IAPYESORNOToJSON(value.hasGrowthRate),
        'GrowthRatePercentage': value.growthRatePercentage,
        'GrowthDate': value.growthDate === undefined ? undefined : (value.growthDate.toISOString()),
    };
}

